



















import { Component, Vue, Prop } from 'vue-property-decorator'
import analytics from '@/analytics'
import { Button } from '@alpha/ink'

export interface Window {
  [key:string]: any; // Add index signature
}

@Component({
  components: {
    Button
  }
})
export default class Transcription extends Vue {
  @Prop() notes!:any
  @Prop() qualNotable!:any
  @Prop() drop!:any

  window: Window = window
  shown: Boolean = false

  get parsedNotes ():any {
    return typeof (this.notes) === 'string' ? JSON.parse(this.notes) : this.notes
  }

  isLogNotable (log:any, index:any):any {
    if (!this.qualNotable.length) {
      return false
    }
    var isNotable = this.qualNotable.findIndex(function (notable:any):any {
      return notable.questionNumber === index && notable.questionText === log.question
    }) !== -1
    return isNotable
  }

  showAnswers () {
    this.shown = true
    analytics.track('Shared Report Show Answers', {
      testId: this.drop.id,
      testType: this.drop.payload.testType
    })
  }

  hideAnswers () {
    this.shown = false
    analytics.track('Shared Report Hide Answers', {
      testId: this.drop.id,
      testType: this.drop.payload.testType
    })
  }
}
